import { createContext, useContext, type ReactNode } from 'react';

/** Element that owns Nova tokens. Portaled menus must mount here. */
export const AdminPortalContext = createContext<HTMLElement | null>(null);

export function useAdminPortalElement() {
  return useContext(AdminPortalContext);
}

export function AdminPortalProvider({
  container,
  children,
}: {
  container: HTMLElement | null;
  children: ReactNode;
}) {
  return <AdminPortalContext.Provider value={container}>{children}</AdminPortalContext.Provider>;
}
